import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'components/Icon';
import styles from '../styles.module.scss';
import ProgressBar from './ProgressBar';

const VolumeControlBar = ({ volumeBarRef, changeVolume, theme, isMobile }) => {
	const [isActive, setIsActive] = useState(true);
	const [currentVolume, setCurrentVolume] = useState(100);
	const [showVolumeStatus, setShowVolumeStatus] = useState(isMobile);

	useEffect(() => {
		volumeBarRef?.current?.style.setProperty(
			'--seek-before-width',
			`${currentVolume}%`
		);
	}, [isActive, showVolumeStatus]);

	useEffect(() => {
		const volume = volumeBarRef.current?.value;
		if (volume || volume === 0) {
			setCurrentVolume(volume);
		}
	}, [volumeBarRef.current?.value]);

	const iconHandleClick = () => {
		setIsActive((prevState) => !prevState);
		changeVolume(isActive ? 0 : currentVolume);
	};

	const hanldeHoverActions = (action) => {
		if (!isMobile) {
			switch (action) {
				case 'enter':
					setShowVolumeStatus(true);
					break;
				case 'leave':
					setShowVolumeStatus(false);
					break;
				default:
					break;
			}
		}
	};

	const handleBlur = (event) => {
		const { relatedTarget, currentTarget } = event;
		const isFocusLost = !currentTarget.contains(relatedTarget);

		if (isFocusLost) {
			hanldeHoverActions('leave');
		}
	};
	const ariaLabel = isActive ? 'Отключить звук' : 'Включить звук';

	return (
		<div
			className={cx(
				styles.VolumeControlBar,
				styles[`VolumeControlBar_${theme}`]
			)}
			onMouseEnter={() => hanldeHoverActions('enter')}
			onMouseLeave={() => hanldeHoverActions('leave')}
			onFocus={() => hanldeHoverActions(hanldeHoverActions('enter'))}
			onBlur={handleBlur}
		>
			<button
				type="button"
				className={styles.VolumeControlBar__Button}
				onClick={iconHandleClick}
				aria-label={ariaLabel}
			>
				<Icon
					className={styles.VolumeControlBar__IconVolume}
					icon="audio-volumeIcon"
				/>
				{!isActive && (
					<Icon
						className={styles.VolumeControlBar__IconMute}
						icon="close-bold"
					/>
				)}
			</button>
			{(isMobile || showVolumeStatus) && isActive && (
				<ProgressBar
					initialValue={currentVolume}
					reference={volumeBarRef}
					onChangeCallback={changeVolume}
					theme={theme}
				/>
			)}
		</div>
	);
};

VolumeControlBar.propTypes = {
	volumeBarRef: PropTypes.object,
	changeVolume: PropTypes.func.isRequired,
	theme: PropTypes.oneOf(['podcast', 'light']),
	isMobile: PropTypes.bool
};

export default VolumeControlBar;
